import React, {useId, useMemo, useRef, useState} from 'react'
import {Box, Flex, useSlotRecipe} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import Slider from '../../../../../leap/components/cms/slider'
import Asset from '../../../../../leap/components/cms/asset'
import {galleryRecipe} from './index.recipe'
import WishlistToggle from '../../../../../components/wishlist-toggle'
import useXleapGalleryImages from '../../../../../leap/hooks/useXleapGalleryImages'
import ZoomImage from '../../../../../leap/components/zoomImage/zoomImage'
import ThumbsSlider from './thumbs'

const Slide = ({asset}) => {
    const videoRef = React.useRef(null)

    const isZoomEnabled = asset.type === 'image'

    const itemNode = (
        <Box aspectRatio={1}>
            <Asset
                asset={asset}
                videoRef={videoRef}
                objectFit="cover"
                widths={{base: '90vw', s: '65vw'}}
                variant={'cockpitGallery'}
            />
        </Box>
    )

    return isZoomEnabled ? <ZoomImage enabled>{itemNode}</ZoomImage> : itemNode
}

if (process.env.NODE_ENV !== 'production') {
    Slide.displayName = 'Slide'
}

Slide.propTypes = {
    asset: PropTypes.object
}

const Gallery = ({product, derivedProduct}) => {
    const mainSliderId = useId()

    const galleryRef = useRef(null)
    const [selectedIndex, setSelectedIndex] = useState(0)

    const recipe = useSlotRecipe({recipe: galleryRecipe})

    const styles = useMemo(() => recipe(), [recipe])

    const galleryItems = useXleapGalleryImages(product, derivedProduct)

    return (
        <Flex {...styles.mainContainer}>
            <Box {...styles.thumbsContainer}>
                <ThumbsSlider
                    items={galleryItems}
                    selectedIndex={selectedIndex}
                    onSelect={(i) => galleryRef.current?.setCurrentIndex(i, {behavior: 'smooth'})}
                    onPrev={() => galleryRef.current?.prev()}
                    onNext={() => galleryRef.current?.next()}
                ></ThumbsSlider>
            </Box>
            <Box {...styles.galleryContainer}>
                <Box pointerEvents="auto" {...styles.wishlistButtonContainer}>
                    <WishlistToggle product={product} variant="cockpitGallery" />
                </Box>
                <Slider
                    ref={galleryRef}
                    variant="cockpitGallery"
                    onIndexChange={setSelectedIndex}
                    sliderId={mainSliderId}
                >
                    {galleryItems.map((item, index) => (
                        <Slide asset={item} key={index} />
                    ))}
                </Slider>
            </Box>
        </Flex>
    )
}

if (process.env.NODE_ENV !== 'production') {
    Gallery.displayName = 'Gallery'
}

Gallery.propTypes = {
    product: PropTypes.object,
    derivedProduct: PropTypes.object
}

export default Gallery
